module.exports = __webpack_public_path__ + "static/media/verticalTrackCardRightImage.88751932.svg";